import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=392c6753&scoped=true&"
import script from "./forgotPassword.vue?vue&type=script&lang=js&"
export * from "./forgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=392c6753&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c6753",
  null
  
)

export default component.exports